/* ======================================================================
   Winkler footer — mobile link-column accordions
   ----------------------------------------------------------------------
   Loaded from sections/wk-footer.liquid. On mobile (≤540px, where the
   footer columns stack) each column heading is a <button> that collapses/
   expands the links below it; the +/− icon and the height animation are
   pure CSS keyed on aria-expanded / .is-open (wk-footer-component.css).
   On desktop the button is inert and aria-expanded is pinned to true so
   assistive tech matches the always-visible links.
   ====================================================================== */
(() => {
  const mq = window.matchMedia('(max-width: 540px)');

  const toggles = () => document.querySelectorAll('.wk-footer__col-toggle');

  const sync = () => {
    toggles().forEach((btn) => {
      const col = btn.closest('.wk-footer__col');
      btn.setAttribute(
        'aria-expanded',
        mq.matches ? String(col.classList.contains('is-open')) : 'true'
      );
    });
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.wk-footer__col-toggle');
    if (!btn || !mq.matches) return;
    const col = btn.closest('.wk-footer__col');
    btn.setAttribute('aria-expanded', String(col.classList.toggle('is-open')));
  });

  mq.addEventListener('change', sync);
  sync();
})();
